import { render, staticRenderFns } from "./baseButton.vue?vue&type=template&id=c477d1bc&scoped=true"
import script from "./baseButton.vue?vue&type=script&lang=js"
export * from "./baseButton.vue?vue&type=script&lang=js"
import style0 from "./baseButton.vue?vue&type=style&index=0&id=c477d1bc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c477d1bc",
  null
  
)

export default component.exports